import { render, staticRenderFns } from "./StaggeredFade.vue?vue&type=template&id=36e18086&"
import script from "./StaggeredFade.vue?vue&type=script&lang=js&"
export * from "./StaggeredFade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports